import { createContext, useContext } from 'react';
import { useKewa } from '../hooks/useKewa';

const KewaContext = createContext(null);

export const KewaProvider = ({ children }) => {
  const kewaHook = useKewa();

  return <KewaContext.Provider value={kewaHook}>{children}</KewaContext.Provider>;
};

export const useKewaTracking = () => {
  const context = useContext(KewaContext);
  if (!context) {
    throw new Error('useKewaTracking must be used within a KewaProvider');
  }
  return context;
};
